<template>
    <v-btn
            @click="$emit('click')"
            :color="color"
            :small="!mobile && !isMobile"
            :disabled="disabled"
            :loading="loading"
            :to="to"
            :href="href"
            :target="target"
            class="c-btn"
            :class="{
              'c-btn_secondary': color === 'secondary',
              'c-btn_tertiary': color === 'tertiary',
            }"
            :width="width"
            elevation="0"
    >
        <slot name="default"></slot>
    </v-btn>
</template>

<script>
export default {
    props: {
        to: {type: Object, default: undefined},
        href: {type: String, default: undefined},
        target: {type: String, default: undefined},
        color: {type: String, default: null},
        disabled: {type: Boolean, default: false},
        loading: {type: Boolean, default: false},
        width: {default: null},
        mobile: {type: Boolean, default: false},
    },
}
</script>

<style lang="scss">
.c-btn {
  &.c-btn_secondary {
    color: #333 !important;
    font-weight: 400;
  }
  &.c-btn_tertiary {
    color: #fff !important;
    font-weight: 400;
  }
  &:not(.v-btn--round).v-size--default {
    height: 40px;
  }
}
</style>